import React from 'react';
import { Link } from 'react-router-dom';
import { CustomMarcaCasaANome } from './CustomMarcasCasaA';

const AuthHeader: React.FC = () => {
  return (
    <nav className="navbar">
      <div className="container-fluid">
        {/* marca */}
        <Link className="navbar-brand" to="/login">
          {/* `text-white` vai no PRÓPRIO svg, não no bloco: o tema pinta o
              primeiro filho da marca com `--adminuiux-text` (regra direta), e
              regra direta ganha de herança — no bloco, a cor não chegaria. */}
          {/* Sem tagline. Ela dizia "Operação" debaixo de um wordmark que já
              escreve CASAA — duas linhas para um nome só. E é no CARTÃO que
              "Operação · Ordens de Serviço" tem função: ali diz de que sistema
              se trata, para quem está prestes a entrar. Decisão dele, 05/09. */}
          <div className="d-inline-block">
            <CustomMarcaCasaANome className="casaa-wordmark text-white" />
          </div>
        </Link>
        <div className="ms-auto"></div>
      </div>
    </nav>
  );
};

export default AuthHeader;
